export default __webpack_public_path__ + "static/media/arrange.137b71c9.jpg";